// Use $ instead of $ without replacing global $
(function ($) {

  var resource_geo;

  function resource_link() {
    setTimeout(function () {
      resource_geo = $('body').attr('data-region');
      // Show Page if Geo location is different
      $('.resource-grid #products ul').find('li').removeClass('new');


      // For product nav only
      $('.resource-grid #products ul').find('li').each(function () {

        if ($(this).hasClass('australia') || $(this).hasClass('india') || $(this).hasClass('africa') || $(this).hasClass('zealand')) {

        } else {
          $(this).addClass('all');
        }
        // console.log(this);
        if ($(this).hasClass('australia') && (resource_geo === 'australia') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else if ($(this).hasClass('zealand') && (resource_geo === 'new_zealand') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else if ($(this).hasClass('india') && (resource_geo === 'in') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else if ($(this).hasClass('africa') && (resource_geo === 'africa') || $(this).hasClass('all')) {
          $(this).css({'display': 'block'});

        } else {
          $(this).css({'display': 'none'});
        }
      });

    }, 500);
  }

  // Language filter update html
  function update_language() {
    var i = 39;
    $('.resource-grid #views-exposed-form-resource-block-1 .form-item-field-language-target-id option').each(function () {
      // console.log(this);
      var text = $(this).text();
      var data = $(this).attr('value');
      // console.log(data, text);
      $('.resource-grid #language ul').append('<li><input type="checkbox" class="checkmark" id='+ i + ' value='+ data +'>' +
          '<label for='+ i + '>' + text + '</label></li>');
      i++;
    });
  }

  $(document).ready(function () {
    resource_link();

    setTimeout(function () {
      $(".resource-grid .nav-wrapper .col-left li select").selectBoxIt({
        //hiding first element
        // showFirstOption: false,
        aggressiveChange: true
      });
    }, 50);

    update_language();
  });

  $(window).on('load', function () {
    $('.resource-grid ').removeClass('grid-view');

    $('body .resource-grid .nav-wrapper .col-right .layout .list-btn').on('click', function () {
      $('body .resource-grid .nav-wrapper .col-right .layout .grid-btn').removeClass('active');
      $(this).addClass('active');
      $('.resource-grid .grid-wrapper').css({"opacity": 0});
      $('.resource-grid ').removeClass('grid-view');
      setTimeout(function () {
        $('.resource-grid .grid-wrapper').animate({"opacity": 1});
      }, 500)
    });

    $('body .resource-grid .nav-wrapper .col-right .layout .grid-btn').on('click', function () {
      $('body .resource-grid .nav-wrapper .col-right .layout .list-btn').removeClass('active');
      $(this).addClass('active');
      $('.resource-grid .grid-wrapper').css({"opacity": 0});
      $('.resource-grid ').addClass('grid-view');
      limit_lines('body .resource-grid .card-box .card-body .inner-content h5 a', 3);
      limit_lines('body .resource-grid .card-box .card-body .inner-content p', 3);
      setTimeout(function () {
        $('.resource-grid .grid-wrapper').animate({"opacity": 1});
      }, 500);

    });

    // limit_lines('body .resource-grid .card-box .card-body .inner-content h5 a', 3);
    // limit_lines('body .resource-grid .card-box .card-body .inner-content p', 3);

    //  resource-grid filter
    $('body .resource-grid .nav-wrapper .col-left').find(".tab-1").click(function (e) {
      e.stopPropagation();
      $('body .resource-grid .nav-wrapper .col-left li').removeClass('active');
      $(this).addClass('active');
      var button_index = $(this).index();
      $('.resource-grid .nav-wrapper .filter-wrap').removeClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content").not(".tab-content:eq(" + button_index + ")").css('display', 'none');
      if ($('.resource-grid .nav-wrapper .clear-element>span').length > 0) {
        $('.resource-grid .nav-wrapper .filter-wrap').addClass('active');
        $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content:eq(" + button_index + ")").fadeIn(500);
        $('body .resource-grid .nav-wrapper .col-left').addClass('clicked');
      }
    });

    $('body .resource-grid .nav-wrapper .col-left').find(".tab-2").click(function (e) {
      e.stopPropagation();
      var button_index = $(this).index();
      $('body .resource-grid .nav-wrapper .col-left li').removeClass('active');
      $(this).addClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').addClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content:eq(" + button_index + ")").fadeIn(500);
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content").not(".tab-content:eq(" + button_index + ")").css('display', 'none');

      $('body .resource-grid .nav-wrapper .col-left').addClass('clicked');
    });

    $('body .resource-grid .nav-wrapper .col-left').find(".tab-3").click(function (e) {
      e.stopPropagation();
      var button_index = $(this).index();
      $('body .resource-grid .nav-wrapper .col-left li').removeClass('active');
      $(this).addClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').addClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content:eq(" + button_index + ")").fadeIn(500);
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content").not(".tab-content:eq(" + button_index + ")").css('display', 'none');

      $('body .resource-grid .nav-wrapper .col-left').addClass('clicked');
    });

    $('body .resource-grid .nav-wrapper .col-left').find(".tab-4").click(function (e) {
      e.stopPropagation();
      var button_index = $(this).index();
      $('body .resource-grid .nav-wrapper .col-left li').removeClass('active');
      $(this).addClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').addClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content:eq(" + button_index + ")").fadeIn(500);
      $('.resource-grid .nav-wrapper .filter-wrap').find(".tab-content").not(".tab-content:eq(" + button_index + ")").css('display', 'none');

      $('body .resource-grid .nav-wrapper .col-left').addClass('clicked');
    });


    $('.resource-grid .nav-wrapper .filter-wrap .close').on('click', function (e) {
      e.stopPropagation();
      $('body .resource-grid .nav-wrapper .col-left li').removeClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').removeClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap .tab-content').removeAttr("style");
      $('body .resource-grid .nav-wrapper .col-left li:eq(0)').addClass('active');

      if ($('.resource-grid .nav-wrapper .clear-element>span').length > 0) {
        $('body .resource-grid .nav-wrapper .col-left li:eq(0)').trigger('click');
      }
    });

    $('.resource-grid #clear-filter .clear-filter').on('click', function () {
      $('body .resource-grid .nav-wrapper .col-left li').removeClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap').removeClass('active');
      $('.resource-grid .nav-wrapper .filter-wrap .tab-content').removeAttr("style");
      $('body .resource-grid .nav-wrapper .col-left li:eq(0)').addClass('active');
    });

// Change the Resource based on Region
    var val_au, val_in, val_af, val_nz;
    val_au = 43;
    val_in = 44;
    val_af = 47;
    val_nz = 48;

    var geo = $('body').attr('data-region');
    if (geo == 'australia') {
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_in + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_af + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_nz + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-submit').trigger('click');
    } else if (geo == 'new_zealand') {
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_au + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_in + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_af + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-submit').trigger('click');
    } else if (geo == 'in') {
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_au + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_nz + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_af + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-submit').trigger('click');
    } else if (geo == 'africa') {
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_au + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_nz + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_in + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-submit').trigger('click');
    } else {
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_au + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_nz + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_in + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-item-field-region-target-id select option[value=' + val_af + ']').attr('selected', true);
      $('#views-exposed-form-resource-block-1 .form-submit').trigger('click');
    }
  });

})(jQuery);